import { useState } from 'react';
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { Mail, MessageCircle } from 'lucide-react';

export const AboutDialog = ({ trigger }) => {
  const [open, setOpen] = useState(false);
  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>{trigger}</DialogTrigger>
      <DialogContent className="max-w-3xl max-h-[85vh] overflow-y-auto" data-testid="about-modal">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: 'Spectral, serif', color: '#163329', fontSize: '1.5rem' }}>
            About Insight Evolution
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-6 pt-4" style={{ color: '#5C635A' }}>
          {/* Company Overview */}
          <div>
            <h3 className="text-lg font-semibold mb-3" style={{ color: '#163329' }}>
              Company Overview, Mission and Objectives
            </h3>
            <p className="mb-3 leading-relaxed">
              Insight Evolution (IE) is the manufacture and the supplier of various online learning products. IE has established the vision to empower and motivate any applicants or Learners or entrepreneurs or Hustlers or Individuals to start business immediately.
            </p>
            <p className="mb-3 leading-relaxed">
              IE is a skill development company and offers Skill development workshops and learn from home tutorials supported by Insight Evolution Website as empowerment programs. Insight Evolution also offers a 7 to 10 days physical evaluation practical after all completed home learning tutorials. IE also offers workshop certificate and accreditation facilitation on certain skills through ARPL programs.
            </p>
            <p className="mb-3 leading-relaxed font-medium" style={{ color: '#163329' }}>
              Briefly Insight Evolution provides products and workshops to learn skills.
            </p>
            <ul className="list-disc pl-6 space-y-2">
              <li>The workshop shortens the learning period very remarkably from years to few months.</li>
              <li>These workshops are created to learn Skills the quickest way and start business immediately everywhere around the world.</li>
              <li>The workshops motivate parents or guardians and sponsors by joining their siblings and children on these workshops and removing them from the streets or drug or liquor related activities.</li>
              <li>Gone are the days where you go to institutions and when you finish you don't have equipments and also you don't have a job experience then you must start afresh then go through an internship.</li>
            </ul>
          </div>

          {/* Remarks and Motivations */}
          <div className="pt-4 border-t" style={{ borderColor: '#E3E1DB' }}>
            <h3 className="text-lg font-semibold mb-3" style={{ color: '#163329' }}>
              Remarks and Motivations
            </h3>
            <ul className="list-disc pl-6 space-y-2">
              <li>Skill can be acquired anytime and by anyone either working or not and can serve as a backup career or fulltime business career.</li>
              <li>If you have finished a diploma or a degree or whatever qualification and you are a free-standing person and you are still looking for a job and you are not successful, then apply this program because you are guaranteed for a job immediately after completion by starting your own business.</li>
              <li>This workshop cannot deter anyone to further any studies they want to pursue in future because it serves as a backup skill anywhere in case you don't get jobs.</li>
              <li>If you see a skill in google and you probably wondering how the skill is created, you are stuck and frustrated then apply this program and it will assist you how to relate with skills.</li>
              <li>This program will assist in providing certificates and also assist on accreditation certificate on other skills.</li>
            </ul>
          </div>

          {/* Summary */}
          <div className="p-4 rounded-lg" style={{ backgroundColor: '#F0EFEA', border: '1px solid #E3E1DB' }}>
            <h4 className="font-semibold mb-2" style={{ color: '#163329' }}>
              In Summary, Insight Evolution Wants if you learn you must:
            </h4>
            <p className="leading-relaxed">
              Own equipment, learn with this equipment and start a business with this equipment. Actually, you are creating a business setup or experience. Learn and experience business in the real world.
            </p>
            <p className="mt-2 italic" style={{ color: '#D86B47' }}>
              Other workshops will be introduced in due time.
            </p>
          </div>

          {/* Contact Information */}
          <div className="pt-4 border-t" style={{ borderColor: '#E3E1DB' }}>
            <h3 className="text-lg font-semibold mb-3" style={{ color: '#163329' }}>
              General Inquiries and Support
            </h3>
            <p className="mb-3 leading-relaxed">
              For general inquiries, kindly click and use the email below or use WhatsApp.
            </p>
            <div className="space-y-2">
              <div className="flex items-center gap-2">
                <Mail className="h-5 w-5" style={{ color: '#163329' }} />
                <a href="mailto:ieskilldev@gmail.com" className="hover:underline" style={{ color: '#D86B47' }}>
                  ieskilldev@gmail.com
                </a>
              </div>
              <div className="flex items-center gap-2">
                <MessageCircle className="h-5 w-5" style={{ color: '#163329' }} />
                <a href="https://wa.me/27766929223" target="_blank" rel="noopener noreferrer" className="hover:underline" style={{ color: '#D86B47' }}>
                  WhatsApp: +27 76 692 9223
                </a>
              </div>
            </div>
          </div>
        </div>
      </DialogContent>
    </Dialog>
  );
};
